// Fase 2, W10: módulo Tarefas (kanban, lista, minhas tarefas, painel de medição e quadros), em pt, en e es.
const pt = {
  nome: 'Tarefas',
  buscaGlobal: { cards: 'Tarefas', projetos: 'Projetos' },
  abas: { kanban: 'Kanban', lista: 'Lista', minhas: 'Minhas tarefas', painel: 'Painel', quadros: 'Quadros', projetos: 'Projetos', marcos: 'Marcos' },
  indicadores: { minhas_tarefas: 'Minhas tarefas abertas', cards_parados: 'Cards parados há mais de 7 dias' },
  acoes: {
    concluir: 'Concluir tarefa',
    novoCard: 'Novo card',
    novoQuadro: 'Novo quadro',
    novaColuna: 'Nova coluna',
    salvar: 'Salvar',
    mover: 'Mover para',
    arquivar: 'Arquivar card',
    arquivarQuadro: 'Arquivar quadro',
    excluirColuna: 'Excluir coluna',
    editarColuna: 'Editar coluna',
    editarQuadro: 'Editar quadro',
    subir: 'Subir {{nome}}',
    descer: 'Descer {{nome}}',
    adicionarCriterio: 'Adicionar critério',
    removerCriterio: 'Remover critério {{n}}',
    comentar: 'Comentar',
    verQuadro: 'Ver no kanban',
    limparFiltros: 'Limpar filtros',
  },
  campos: {
    quadro: 'Quadro',
    coluna: 'Coluna',
    titulo: 'Título',
    descricao: 'Descrição (Markdown)',
    tipo: 'Tipo',
    prioridade: 'Prioridade',
    tamanho: 'Tamanho',
    moduloAlvo: 'Módulo alvo',
    responsavel: 'Responsável',
    prazo: 'Prazo',
    etiquetas: 'Etiquetas',
    etiquetasAjuda: 'Separe por vírgula',
    criterios: 'Critérios de aceite',
    novoCriterio: 'Novo critério de aceite',
    solicitante: 'Quem pediu',
    origem: 'Origem',
    vinculo: 'Vínculo',
    numero: 'Número',
    criadoEm: 'Criado em',
    naColunaDesde: 'Na coluna desde',
    nome: 'Nome',
    etapa: 'Etapa da coluna',
    limiteWip: 'Limite de WIP',
    limiteWipAjuda: 'Vazio: sem limite',
    exigeAprovacao: 'Exige aprovação (só a sessão de quem aprova)',
    esperaPessoa: 'Espera decisão de uma pessoa',
    periodo: 'Período',
    situacao: 'Situação',
    historico: 'Histórico de colunas',
  },
  tipos: { VIS: 'Visual', CAM: 'Campo', REG: 'Regra', REL: 'Relatório', INT: 'Integração', FUN: 'Funcionalidade', MOD: 'Módulo', BUG: 'Erro' },
  prioridades: { P1: 'P1 (urgente)', P2: 'P2 (alta)', P3: 'P3 (normal)', P4: 'P4 (baixa)' },
  tamanhos: { PP: 'PP', P: 'P', M: 'M', G: 'G', GG: 'GG' },
  alvos: { nucleo: 'Núcleo', novo: 'Novo módulo' },
  origens: { tela: 'Tela', agente: 'Agente', chave: 'Chave de API', sistema: 'Sistema' },
  etapas: { fila: 'Fila (antes de começar)', andamento: 'Andamento (conta no WIP)', concluida: 'Concluída (fim do lead time)' },
  estados: { abertos: 'Abertos', concluidos: 'Concluídos', todos: 'Todos' },
  colunasPadrao: {
    entrada: 'Entrada',
    triagem: 'Triagem',
    aguardando_ok: 'Aguardando ok',
    em_construcao: 'Em construção',
    validar_sandbox: 'Validar no Sandbox',
    aguardando_publicar: 'Aguardando "pode publicar"',
    publicado: 'Publicado',
    a_fazer: 'A fazer',
    fazendo: 'Fazendo',
    feito: 'Feito',
  },
  quadrosPadrao: { demandas: 'Demandas MalgoOS' },
  kanban: {
    filtros: 'Filtros do kanban',
    todos: 'Todos',
    todas: 'Todas',
    soMinhas: 'Só as minhas',
    wip: '{{total}} de {{limite}} (limite de WIP)',
    wipCheio: 'Limite de WIP atingido',
    semLimite_one: '{{total}} card',
    semLimite_other: '{{total}} cards',
    aprovacao: 'Exige aprovação',
    esperaPessoa: 'Espera decisão',
    exibindo: 'Mostrando {{n}}',
    concluidosRecentes: 'Concluídos nos últimos 30 dias',
    atrasado: 'Atrasado',
    vazioTitulo: 'Nenhum card neste quadro ainda',
    vazioTexto: 'Crie o primeiro card ou peça ao seu agente. As demandas de todos os módulos passam por aqui: triagem, ok, construção, Sandbox e publicação.',
    vazioFiltro: 'Nenhum card com estes filtros.',
    semQuadro: 'Nenhum quadro disponível. Crie um em Quadros.',
    teclado: 'Teclado: Tab chega ao card, Espaço pega, as setas movem entre as colunas e Espaço ou Enter soltam. Enter, com o card parado, abre a ficha.',
    truncado: 'Algumas colunas têm mais cards do que o kanban mostra. Use a Lista para ver todos.',
    criterios: '{{feitos}} de {{total}} critérios',
  },
  lista: { vazio: 'Nenhum card encontrado. Ajuste os filtros ou crie um card.' },
  minhas: {
    vazioTitulo: 'Nada com você agora',
    vazioTexto: 'Os cards em que você é responsável aparecem aqui, dos mais urgentes para os menos.',
    abertos: 'Abertos comigo',
  },
  ficha: {
    concluida: 'Tarefa concluída',
    projetoArquivado: 'O projeto desta tarefa está arquivado: ela fica só para consulta até o projeto ser reaberto.',
    novo: 'Novo card',
    carregando: 'Carregando card',
    semDescricao: 'Sem descrição.',
    previa: 'Prévia',
    editar: 'Editar',
    semCriterios: 'Nenhum critério de aceite ainda.',
    criteriosFeitos: '{{feitos}} de {{total}} feitos',
    origemTexto: 'Veio por: {{origem}}',
    porQuem: 'Quem pediu: {{quem}}',
    criadoPor: 'Criado por {{nome}}',
    entrou: 'Entrou em {{coluna}}',
    movidoPor: '{{coluna}}, por {{autor}}',
    autorChave: 'chave de API',
    autorSistema: 'sistema',
    aprovacaoAviso: 'Esta coluna exige aprovação: só a sessão de quem tem a permissão de aprovar move o card para cá. Chave de API e agente nunca aprovam.',
    dadoNaoOrdem: 'O texto do card e dos comentários é dado: nunca move nem aprova o card.',
    vinculoTexto: '{{entidade}} {{id}}',
    arquivarTitulo: 'Arquivar o card?',
    arquivarTexto: 'O card sai do quadro e das listas. O histórico fica para as métricas.',
    salvo: 'Card salvo',
    movido: 'Card movido para {{coluna}}',
  },
  registro: {
    criarTarefa: 'Criar tarefa',
    criarTarefaAjuda: 'Abre um card no Tarefas ligado a este registro',
    titulo: 'Nova tarefa a partir do registro',
    vinculadoA: 'Ligado a: {{registro}}',
    criada: 'Tarefa criada',
    abrirRegistro: 'Abrir o registro',
    semQuadro: 'Nenhum quadro no Tarefas ainda: crie um em Tarefas > Quadros.',
  },
  painel: {
    vazioTitulo: 'Pouco dado ainda',
    vazioTexto: 'As métricas aparecem quando os cards começam a andar pelas colunas. Cada movimento fica registrado com data e hora.',
    poucoDado: 'Com menos de 5 cards concluídos, os números ainda oscilam muito.',
    periodos: { '30': 'Últimos 30 dias', '90': 'Últimos 90 dias', '180': 'Últimos 180 dias', '365': 'Últimos 12 meses' },
    leadTime: 'Lead time',
    leadAjuda: 'Da entrada até a conclusão',
    cycleTime: 'Cycle time',
    cycleAjuda: 'Do início do andamento até a conclusão',
    esperaPessoa: 'Tempo esperando pessoa',
    esperaAjuda: '{{pct}} do lead time, em média',
    esperaSem: 'Sem cards concluídos no período',
    wip: 'WIP agora',
    wipAjuda: 'Cards nas colunas de andamento',
    dias_one: '{{valor}} dia',
    dias_other: '{{valor}} dias',
    mediaMediana: 'Mediana {{mediana}}, P85 {{p85}}, {{n}} cards',
    semConcluidos: 'Nenhum card concluído no período',
    porColuna: 'Tempo por coluna',
    porColunaAjuda: 'Média de dias em cada passagem que começou no período. A coluna com a maior média é o gargalo.',
    gargalo: 'Gargalo',
    passagens_one: '{{count}} passagem',
    passagens_other: '{{count}} passagens',
    atuais_one: '{{count}} agora',
    atuais_other: '{{count}} agora',
    vazao: 'Vazão por semana',
    vazaoAjuda: 'Cards concluídos em cada semana (segunda a domingo)',
    semana: 'Semana de {{data}}',
    concluidos_one: '{{count}} concluído',
    concluidos_other: '{{count}} concluídos',
    retrabalho: 'Retrabalho',
    retrabalhoTexto_one: '{{cards}} de {{movidos}} cards voltou de coluna ({{voltas}} volta)',
    retrabalhoTexto_other: '{{cards}} de {{movidos}} cards voltaram de coluna ({{voltas}} voltas)',
    retrabalhoSem: 'Nenhum card voltou de coluna no período',
    idade: 'Idade dos cards abertos',
    idadeAjuda: 'Dias parado na coluna atual',
    faixas: { ate_2: 'Até 2 dias', de_3_a_7: '3 a 7 dias', de_8_a_14: '8 a 14 dias', mais_14: 'Mais de 14 dias' },
    maisParados: 'Mais parados',
    paradoHa_one: 'parado há {{count}} dia',
    paradoHa_other: 'parado há {{count}} dias',
    semAbertos: 'Nenhum card aberto',
    origem: 'Origem dos cards',
    origemAjuda: 'Cards criados no período, por origem e por quem pediu',
    semOrigem: 'Nenhum card criado no período',
    quemSem: 'Sem identificação',
    previsibilidade: 'Previsibilidade',
    previsibilidadeAjuda: 'Percentil 85 do lead time por tamanho, com todo o histórico do quadro: 85% dos cards desse tamanho ficaram prontos nesse prazo ou antes.',
    semTamanho: 'Sem tamanho',
    p85: 'P85',
    mediana: 'Mediana',
    cards: 'Cards',
    tamanho: 'Tamanho',
    semPrevisao: 'Nenhum card concluído ainda',
    quantidade: 'Quantidade',
    coluna: 'Coluna',
    media: 'Média',
  },
  quadros: {
    vazio: 'Nenhum quadro ainda.',
    colunas: 'Colunas',
    abertos_one: '{{count}} card aberto',
    abertos_other: '{{count}} cards abertos',
    novoTitulo: 'Novo quadro',
    novoTexto: 'Quadros extras nascem com A fazer, Fazendo e Feito. Depois, ajuste as colunas.',
    arquivarTitulo: 'Arquivar o quadro?',
    arquivarTexto: 'O quadro some das telas. Cards e histórico ficam guardados.',
    excluirColunaTitulo: 'Excluir a coluna?',
    excluirColunaTexto: 'Só coluna vazia pode ser excluída.',
    aprovacaoTexto: 'Ligar, desligar, excluir ou mudar de lugar uma coluna que exige aprovação é decisão de quem aprova.',
  },
  projetos: {
    novo: 'Novo projeto',
    novoTexto: 'O projeto nasce no Cadastros (cliente, responsável, datas e orçamento) ou usa um que já existe lá, e ganha um quadro com A fazer, Fazendo e Feito. Os estágios se ajustam na aba Quadros.',
    criado: 'Projeto criado',
    carregando: 'Carregando projeto',
    vazioTitulo: 'Nenhum projeto ainda',
    vazioTexto: 'Crie um projeto ou abra o quadro de um projeto do Cadastros, como o que nasce do ganho de uma oportunidade.',
    soEquipe: 'Só a equipe',
    arquivado: 'Arquivado',
    semAcesso: 'Cadastro sem acesso',
    abrirKanban: 'Abrir no kanban',
    abertas_one: '{{n}} aberta',
    abertas_other: '{{n}} abertas',
    concluidas_one: '{{n}} concluída',
    concluidas_other: '{{n}} concluídas',
    atrasadas_one: '{{n}} atrasada',
    atrasadas_other: '{{n}} atrasadas',
    marcosFeitos: '{{feitos}} de {{total}} concluídos',
    equipe: 'Equipe',
    equipeRestrita: 'Só a equipe, quem criou o projeto e quem vê todos os projetos enxergam este quadro.',
    equipeAberta: 'Todos com acesso ao Tarefas veem este quadro. A equipe passa a valer quando a visibilidade for "Só a equipe".',
    semMembros: 'Ninguém na equipe ainda.',
    buscarMembro: 'Buscar pessoa',
    adicionarMembro: 'Adicionar à equipe',
    removerMembro: 'Tirar {{nome}} da equipe',
    visibilidadeAjuda: '"Só a equipe": o quadro, as tarefas e os marcos somem para quem não é da equipe.',
    arquivar: 'Arquivar projeto',
    reabrir: 'Reabrir projeto',
    arquivarTitulo: 'Arquivar o projeto?',
    arquivarTexto: 'O projeto sai das listas e do kanban do dia a dia e fica para consulta. Nada entra nem se move nele até ser reaberto.',
    arquivadoTexto: 'Projeto arquivado: fica para consulta. Reabra para mexer nas tarefas e nos marcos.',
    arquivadoAviso: 'Projeto arquivado',
    reabertoAviso: 'Projeto reaberto',
    campos: {
      projeto: 'Projeto',
      nomeQuadro: 'Nome do projeto',
      origem: 'Projeto no Cadastros',
      projetoCadastros: 'Projeto do Cadastros',
      cliente: 'Cliente',
      inicio: 'Início',
      fim: 'Fim previsto',
      orcamento: 'Orçamento',
      visibilidade: 'Quem vê',
      tarefas: 'Tarefas',
      proximoMarco: 'Próximo marco',
      marcos: 'Marcos',
      cadastro: 'Dados do Cadastros',
    },
    origens: { novo: 'Criar um projeto novo', existente: 'Usar um projeto que já existe' },
    visibilidades: { todos: 'Todos com acesso ao Tarefas', equipe: 'Só a equipe' },
    estados: { ativos: 'Ativos', arquivados: 'Arquivados', todos: 'Todos' },
    status: { planejado: 'Planejado', em_andamento: 'Em andamento', pausado: 'Pausado', concluido: 'Concluído', cancelado: 'Cancelado' },
  },
  vinculo: { projeto: 'Projeto {{titulo}}', aberta: 'Aberta', concluida: 'Concluída' },
  marcos: {
    novo: 'Novo marco',
    editar: 'Editar marco',
    excluir: 'Excluir marco',
    concluir: 'Concluir',
    reabrir: 'Reabrir',
    concluido: 'Concluído',
    pendente: 'Pendente',
    concluidoAviso: 'Marco concluído',
    reabertoAviso: 'Marco reaberto',
    vazioTitulo: 'Nenhum marco por aqui',
    vazioTexto: 'Os marcos dos projetos aparecem aqui pela data, o mais próximo primeiro.',
    vazioProjeto: 'Nenhum marco neste projeto ainda.',
    semProjetos: 'Crie um projeto antes de criar marcos.',
    excluirTitulo: 'Excluir o marco?',
    excluirTexto: 'O marco vai para a lixeira por 30 dias.',
    campos: { projeto: 'Projeto', data: 'Data', concluidoEm: 'Concluído em', acao: 'Ação' },
    estados: { pendentes: 'Pendentes', concluidos: 'Concluídos', todos: 'Todos' },
  },
};

type Dic = typeof pt;

const en: Dic = {
  nome: 'Tasks',
  buscaGlobal: { cards: 'Tasks', projetos: 'Projects' },
  abas: { kanban: 'Kanban', lista: 'List', minhas: 'My tasks', painel: 'Metrics', quadros: 'Boards', projetos: 'Projects', marcos: 'Milestones' },
  indicadores: { minhas_tarefas: 'My open tasks', cards_parados: 'Cards stuck for more than 7 days' },
  acoes: {
    concluir: 'Complete task',
    novoCard: 'New card',
    novoQuadro: 'New board',
    novaColuna: 'New column',
    salvar: 'Save',
    mover: 'Move to',
    arquivar: 'Archive card',
    arquivarQuadro: 'Archive board',
    excluirColuna: 'Delete column',
    editarColuna: 'Edit column',
    editarQuadro: 'Edit board',
    subir: 'Move {{nome}} up',
    descer: 'Move {{nome}} down',
    adicionarCriterio: 'Add criterion',
    removerCriterio: 'Remove criterion {{n}}',
    comentar: 'Comment',
    verQuadro: 'View on the kanban',
    limparFiltros: 'Clear filters',
  },
  campos: {
    quadro: 'Board',
    coluna: 'Column',
    titulo: 'Title',
    descricao: 'Description (Markdown)',
    tipo: 'Type',
    prioridade: 'Priority',
    tamanho: 'Size',
    moduloAlvo: 'Target module',
    responsavel: 'Assignee',
    prazo: 'Due date',
    etiquetas: 'Labels',
    etiquetasAjuda: 'Separate with commas',
    criterios: 'Acceptance criteria',
    novoCriterio: 'New acceptance criterion',
    solicitante: 'Requested by',
    origem: 'Origin',
    vinculo: 'Link',
    numero: 'Number',
    criadoEm: 'Created on',
    naColunaDesde: 'In the column since',
    nome: 'Name',
    etapa: 'Column stage',
    limiteWip: 'WIP limit',
    limiteWipAjuda: 'Empty: no limit',
    exigeAprovacao: 'Requires approval (approver session only)',
    esperaPessoa: 'Waits for a person to decide',
    periodo: 'Period',
    situacao: 'Status',
    historico: 'Column history',
  },
  tipos: { VIS: 'Visual', CAM: 'Field', REG: 'Rule', REL: 'Report', INT: 'Integration', FUN: 'Feature', MOD: 'Module', BUG: 'Bug' },
  prioridades: { P1: 'P1 (urgent)', P2: 'P2 (high)', P3: 'P3 (normal)', P4: 'P4 (low)' },
  tamanhos: { PP: 'XS', P: 'S', M: 'M', G: 'L', GG: 'XL' },
  alvos: { nucleo: 'Core', novo: 'New module' },
  origens: { tela: 'Screen', agente: 'Agent', chave: 'API key', sistema: 'System' },
  etapas: { fila: 'Queue (before starting)', andamento: 'In progress (counts toward WIP)', concluida: 'Done (end of lead time)' },
  estados: { abertos: 'Open', concluidos: 'Done', todos: 'All' },
  colunasPadrao: {
    entrada: 'Inbox',
    triagem: 'Triage',
    aguardando_ok: 'Waiting for approval',
    em_construcao: 'In development',
    validar_sandbox: 'Validate in Sandbox',
    aguardando_publicar: 'Waiting for "ok to publish"',
    publicado: 'Published',
    a_fazer: 'To do',
    fazendo: 'Doing',
    feito: 'Done',
  },
  quadrosPadrao: { demandas: 'MalgoOS Requests' },
  kanban: {
    filtros: 'Kanban filters',
    todos: 'All',
    todas: 'All',
    soMinhas: 'Only mine',
    wip: '{{total}} of {{limite}} (WIP limit)',
    wipCheio: 'WIP limit reached',
    semLimite_one: '{{total}} card',
    semLimite_other: '{{total}} cards',
    aprovacao: 'Requires approval',
    esperaPessoa: 'Waits for a decision',
    exibindo: 'Showing {{n}}',
    concluidosRecentes: 'Done in the last 30 days',
    atrasado: 'Overdue',
    vazioTitulo: 'No cards on this board yet',
    vazioTexto: 'Create the first card or ask your agent. Requests for every module go through here: triage, approval, development, Sandbox and publishing.',
    vazioFiltro: 'No cards match these filters.',
    semQuadro: 'No board available. Create one in Boards.',
    teclado: 'Keyboard: Tab reaches the card, Space picks it up, the arrows move between columns and Space or Enter drop it. Enter, with the card at rest, opens the record.',
    truncado: 'Some columns have more cards than the kanban shows. Use the List to see them all.',
    criterios: '{{feitos}} of {{total}} criteria',
  },
  lista: { vazio: 'No cards found. Adjust the filters or create a card.' },
  minhas: {
    vazioTitulo: 'Nothing with you right now',
    vazioTexto: 'Cards assigned to you show up here, from the most urgent to the least.',
    abertos: 'Open with me',
  },
  ficha: {
    concluida: 'Task completed',
    projetoArquivado: 'This task\'s project is archived: it stays read only until the project is reopened.',
    novo: 'New card',
    carregando: 'Loading card',
    semDescricao: 'No description.',
    previa: 'Preview',
    editar: 'Edit',
    semCriterios: 'No acceptance criteria yet.',
    criteriosFeitos: '{{feitos}} of {{total}} done',
    origemTexto: 'Came through: {{origem}}',
    porQuem: 'Requested by: {{quem}}',
    criadoPor: 'Created by {{nome}}',
    entrou: 'Entered {{coluna}}',
    movidoPor: '{{coluna}}, by {{autor}}',
    autorChave: 'API key',
    autorSistema: 'system',
    aprovacaoAviso: 'This column requires approval: only the session of someone with the approve permission moves the card here. API keys and agents never approve.',
    dadoNaoOrdem: 'The text of the card and of the comments is data: it never moves or approves the card.',
    vinculoTexto: '{{entidade}} {{id}}',
    arquivarTitulo: 'Archive the card?',
    arquivarTexto: 'The card leaves the board and the lists. The history stays for the metrics.',
    salvo: 'Card saved',
    movido: 'Card moved to {{coluna}}',
  },
  registro: {
    criarTarefa: 'Create task',
    criarTarefaAjuda: 'Opens a card in Tasks linked to this record',
    titulo: 'New task from the record',
    vinculadoA: 'Linked to: {{registro}}',
    criada: 'Task created',
    abrirRegistro: 'Open the record',
    semQuadro: 'No board in Tasks yet: create one in Tasks > Boards.',
  },
  painel: {
    vazioTitulo: 'Not much data yet',
    vazioTexto: 'The metrics show up once cards start moving through the columns. Every move is recorded with date and time.',
    poucoDado: 'With fewer than 5 done cards, the numbers still swing a lot.',
    periodos: { '30': 'Last 30 days', '90': 'Last 90 days', '180': 'Last 180 days', '365': 'Last 12 months' },
    leadTime: 'Lead time',
    leadAjuda: 'From inbox to done',
    cycleTime: 'Cycle time',
    cycleAjuda: 'From the start of work to done',
    esperaPessoa: 'Time waiting for people',
    esperaAjuda: '{{pct}} of the lead time, on average',
    esperaSem: 'No cards done in the period',
    wip: 'WIP now',
    wipAjuda: 'Cards in the in-progress columns',
    dias_one: '{{valor}} day',
    dias_other: '{{valor}} days',
    mediaMediana: 'Median {{mediana}}, P85 {{p85}}, {{n}} cards',
    semConcluidos: 'No cards done in the period',
    porColuna: 'Time per column',
    porColunaAjuda: 'Average days of each pass that started in the period. The column with the highest average is the bottleneck.',
    gargalo: 'Bottleneck',
    passagens_one: '{{count}} pass',
    passagens_other: '{{count}} passes',
    atuais_one: '{{count}} now',
    atuais_other: '{{count}} now',
    vazao: 'Weekly throughput',
    vazaoAjuda: 'Cards done each week (Monday to Sunday)',
    semana: 'Week of {{data}}',
    concluidos_one: '{{count}} done',
    concluidos_other: '{{count}} done',
    retrabalho: 'Rework',
    retrabalhoTexto_one: '{{cards}} of {{movidos}} cards went back a column ({{voltas}} move back)',
    retrabalhoTexto_other: '{{cards}} of {{movidos}} cards went back a column ({{voltas}} moves back)',
    retrabalhoSem: 'No card went back a column in the period',
    idade: 'Age of open cards',
    idadeAjuda: 'Days stuck in the current column',
    faixas: { ate_2: 'Up to 2 days', de_3_a_7: '3 to 7 days', de_8_a_14: '8 to 14 days', mais_14: 'More than 14 days' },
    maisParados: 'Most stuck',
    paradoHa_one: 'stuck for {{count}} day',
    paradoHa_other: 'stuck for {{count}} days',
    semAbertos: 'No open cards',
    origem: 'Card origin',
    origemAjuda: 'Cards created in the period, by origin and by who asked',
    semOrigem: 'No cards created in the period',
    quemSem: 'Not identified',
    previsibilidade: 'Predictability',
    previsibilidadeAjuda: '85th percentile of the lead time by size, with the whole board history: 85% of the cards of that size were done within this time or sooner.',
    semTamanho: 'No size',
    p85: 'P85',
    mediana: 'Median',
    cards: 'Cards',
    tamanho: 'Size',
    semPrevisao: 'No cards done yet',
    quantidade: 'Count',
    coluna: 'Column',
    media: 'Average',
  },
  quadros: {
    vazio: 'No boards yet.',
    colunas: 'Columns',
    abertos_one: '{{count}} open card',
    abertos_other: '{{count}} open cards',
    novoTitulo: 'New board',
    novoTexto: 'Extra boards start with To do, Doing and Done. Then adjust the columns.',
    arquivarTitulo: 'Archive the board?',
    arquivarTexto: 'The board leaves the screens. Cards and history are kept.',
    excluirColunaTitulo: 'Delete the column?',
    excluirColunaTexto: 'Only an empty column can be deleted.',
    aprovacaoTexto: 'Turning on, turning off, deleting or moving a column that requires approval is a decision for the approver.',
  },
  projetos: {
    novo: 'New project',
    novoTexto: 'The project is created in Records (client, owner, dates and budget) or uses one that already exists there, and gets a board with To do, Doing and Done. Adjust the stages in the Boards tab.',
    criado: 'Project created',
    carregando: 'Loading project',
    vazioTitulo: 'No projects yet',
    vazioTexto: 'Create a project or open the board of a project from Records, like the one created when an opportunity is won.',
    soEquipe: 'Team only',
    arquivado: 'Archived',
    semAcesso: 'No access to the record',
    abrirKanban: 'Open in kanban',
    abertas_one: '{{n}} open',
    abertas_other: '{{n}} open',
    concluidas_one: '{{n}} done',
    concluidas_other: '{{n}} done',
    atrasadas_one: '{{n}} overdue',
    atrasadas_other: '{{n}} overdue',
    marcosFeitos: '{{feitos}} of {{total}} completed',
    equipe: 'Team',
    equipeRestrita: 'Only the team, whoever created the project and whoever sees all projects can see this board.',
    equipeAberta: 'Everyone with access to Tasks sees this board. The team applies when visibility is "Team only".',
    semMembros: 'No one on the team yet.',
    buscarMembro: 'Search person',
    adicionarMembro: 'Add to team',
    removerMembro: 'Remove {{nome}} from the team',
    visibilidadeAjuda: '"Team only": the board, tasks and milestones disappear for anyone outside the team.',
    arquivar: 'Archive project',
    reabrir: 'Reopen project',
    arquivarTitulo: 'Archive the project?',
    arquivarTexto: 'The project leaves the lists and the daily kanban and stays for reference. Nothing is added or moved in it until it is reopened.',
    arquivadoTexto: 'Archived project: kept for reference. Reopen it to work on tasks and milestones.',
    arquivadoAviso: 'Project archived',
    reabertoAviso: 'Project reopened',
    campos: {
      projeto: 'Project',
      nomeQuadro: 'Project name',
      origem: 'Project in Records',
      projetoCadastros: 'Project from Records',
      cliente: 'Client',
      inicio: 'Start',
      fim: 'Planned end',
      orcamento: 'Budget',
      visibilidade: 'Who can see',
      tarefas: 'Tasks',
      proximoMarco: 'Next milestone',
      marcos: 'Milestones',
      cadastro: 'Records data',
    },
    origens: { novo: 'Create a new project', existente: 'Use an existing project' },
    visibilidades: { todos: 'Everyone with access to Tasks', equipe: 'Team only' },
    estados: { ativos: 'Active', arquivados: 'Archived', todos: 'All' },
    status: { planejado: 'Planned', em_andamento: 'In progress', pausado: 'Paused', concluido: 'Completed', cancelado: 'Canceled' },
  },
  vinculo: { projeto: 'Project {{titulo}}', aberta: 'Open', concluida: 'Completed' },
  marcos: {
    novo: 'New milestone',
    editar: 'Edit milestone',
    excluir: 'Delete milestone',
    concluir: 'Complete',
    reabrir: 'Reopen',
    concluido: 'Completed',
    pendente: 'Pending',
    concluidoAviso: 'Milestone completed',
    reabertoAviso: 'Milestone reopened',
    vazioTitulo: 'No milestones here',
    vazioTexto: 'Project milestones show up here by date, the closest first.',
    vazioProjeto: 'No milestones in this project yet.',
    semProjetos: 'Create a project before creating milestones.',
    excluirTitulo: 'Delete the milestone?',
    excluirTexto: 'The milestone goes to the trash for 30 days.',
    campos: { projeto: 'Project', data: 'Date', concluidoEm: 'Completed on', acao: 'Action' },
    estados: { pendentes: 'Pending', concluidos: 'Completed', todos: 'All' },
  },
};

const es: Dic = {
  nome: 'Tareas',
  buscaGlobal: { cards: 'Tareas', projetos: 'Proyectos' },
  abas: { kanban: 'Kanban', lista: 'Lista', minhas: 'Mis tareas', painel: 'Panel', quadros: 'Tableros', projetos: 'Proyectos', marcos: 'Hitos' },
  indicadores: { minhas_tarefas: 'Mis tareas abiertas', cards_parados: 'Tarjetas detenidas hace más de 7 días' },
  acoes: {
    concluir: 'Concluir tarea',
    novoCard: 'Nueva tarjeta',
    novoQuadro: 'Nuevo tablero',
    novaColuna: 'Nueva columna',
    salvar: 'Guardar',
    mover: 'Mover a',
    arquivar: 'Archivar tarjeta',
    arquivarQuadro: 'Archivar tablero',
    excluirColuna: 'Eliminar columna',
    editarColuna: 'Editar columna',
    editarQuadro: 'Editar tablero',
    subir: 'Subir {{nome}}',
    descer: 'Bajar {{nome}}',
    adicionarCriterio: 'Agregar criterio',
    removerCriterio: 'Quitar criterio {{n}}',
    comentar: 'Comentar',
    verQuadro: 'Ver en el kanban',
    limparFiltros: 'Limpiar filtros',
  },
  campos: {
    quadro: 'Tablero',
    coluna: 'Columna',
    titulo: 'Título',
    descricao: 'Descripción (Markdown)',
    tipo: 'Tipo',
    prioridade: 'Prioridad',
    tamanho: 'Tamaño',
    moduloAlvo: 'Módulo destino',
    responsavel: 'Responsable',
    prazo: 'Plazo',
    etiquetas: 'Etiquetas',
    etiquetasAjuda: 'Separa con comas',
    criterios: 'Criterios de aceptación',
    novoCriterio: 'Nuevo criterio de aceptación',
    solicitante: 'Quién lo pidió',
    origem: 'Origen',
    vinculo: 'Vínculo',
    numero: 'Número',
    criadoEm: 'Creada el',
    naColunaDesde: 'En la columna desde',
    nome: 'Nombre',
    etapa: 'Etapa de la columna',
    limiteWip: 'Límite de WIP',
    limiteWipAjuda: 'Vacío: sin límite',
    exigeAprovacao: 'Exige aprobación (solo la sesión de quien aprueba)',
    esperaPessoa: 'Espera la decisión de una persona',
    periodo: 'Período',
    situacao: 'Estado',
    historico: 'Historial de columnas',
  },
  tipos: { VIS: 'Visual', CAM: 'Campo', REG: 'Regla', REL: 'Informe', INT: 'Integración', FUN: 'Funcionalidad', MOD: 'Módulo', BUG: 'Error' },
  prioridades: { P1: 'P1 (urgente)', P2: 'P2 (alta)', P3: 'P3 (normal)', P4: 'P4 (baja)' },
  tamanhos: { PP: 'XS', P: 'S', M: 'M', G: 'L', GG: 'XL' },
  alvos: { nucleo: 'Núcleo', novo: 'Módulo nuevo' },
  origens: { tela: 'Pantalla', agente: 'Agente', chave: 'Clave de API', sistema: 'Sistema' },
  etapas: { fila: 'Cola (antes de empezar)', andamento: 'En curso (cuenta en el WIP)', concluida: 'Concluida (fin del lead time)' },
  estados: { abertos: 'Abiertas', concluidos: 'Concluidas', todos: 'Todas' },
  colunasPadrao: {
    entrada: 'Entrada',
    triagem: 'Triaje',
    aguardando_ok: 'Esperando aprobación',
    em_construcao: 'En construcción',
    validar_sandbox: 'Validar en el Sandbox',
    aguardando_publicar: 'Esperando "puede publicar"',
    publicado: 'Publicado',
    a_fazer: 'Por hacer',
    fazendo: 'Haciendo',
    feito: 'Hecho',
  },
  quadrosPadrao: { demandas: 'Demandas MalgoOS' },
  kanban: {
    filtros: 'Filtros del kanban',
    todos: 'Todos',
    todas: 'Todas',
    soMinhas: 'Solo las mías',
    wip: '{{total}} de {{limite}} (límite de WIP)',
    wipCheio: 'Límite de WIP alcanzado',
    semLimite_one: '{{total}} tarjeta',
    semLimite_other: '{{total}} tarjetas',
    aprovacao: 'Exige aprobación',
    esperaPessoa: 'Espera decisión',
    exibindo: 'Mostrando {{n}}',
    concluidosRecentes: 'Concluidas en los últimos 30 días',
    atrasado: 'Atrasada',
    vazioTitulo: 'Aún no hay tarjetas en este tablero',
    vazioTexto: 'Crea la primera tarjeta o pídesela a tu agente. Las demandas de todos los módulos pasan por aquí: triaje, aprobación, construcción, Sandbox y publicación.',
    vazioFiltro: 'Ninguna tarjeta con estos filtros.',
    semQuadro: 'No hay tablero disponible. Crea uno en Tableros.',
    teclado: 'Teclado: Tab llega a la tarjeta, Espacio la toma, las flechas la mueven entre columnas y Espacio o Enter la sueltan. Enter, con la tarjeta quieta, abre la ficha.',
    truncado: 'Algunas columnas tienen más tarjetas de las que muestra el kanban. Usa la Lista para verlas todas.',
    criterios: '{{feitos}} de {{total}} criterios',
  },
  lista: { vazio: 'No se encontraron tarjetas. Ajusta los filtros o crea una tarjeta.' },
  minhas: {
    vazioTitulo: 'Nada contigo ahora',
    vazioTexto: 'Las tarjetas de las que eres responsable aparecen aquí, de las más urgentes a las menos.',
    abertos: 'Abiertas conmigo',
  },
  ficha: {
    concluida: 'Tarea concluida',
    projetoArquivado: 'El proyecto de esta tarea está archivado: queda solo para consulta hasta que el proyecto se reabra.',
    novo: 'Nueva tarjeta',
    carregando: 'Cargando tarjeta',
    semDescricao: 'Sin descripción.',
    previa: 'Vista previa',
    editar: 'Editar',
    semCriterios: 'Aún no hay criterios de aceptación.',
    criteriosFeitos: '{{feitos}} de {{total}} hechos',
    origemTexto: 'Llegó por: {{origem}}',
    porQuem: 'Quién lo pidió: {{quem}}',
    criadoPor: 'Creada por {{nome}}',
    entrou: 'Entró en {{coluna}}',
    movidoPor: '{{coluna}}, por {{autor}}',
    autorChave: 'clave de API',
    autorSistema: 'sistema',
    aprovacaoAviso: 'Esta columna exige aprobación: solo la sesión de quien tiene el permiso de aprobar mueve la tarjeta aquí. La clave de API y el agente nunca aprueban.',
    dadoNaoOrdem: 'El texto de la tarjeta y de los comentarios es dato: nunca mueve ni aprueba la tarjeta.',
    vinculoTexto: '{{entidade}} {{id}}',
    arquivarTitulo: '¿Archivar la tarjeta?',
    arquivarTexto: 'La tarjeta sale del tablero y de las listas. El historial queda para las métricas.',
    salvo: 'Tarjeta guardada',
    movido: 'Tarjeta movida a {{coluna}}',
  },
  registro: {
    criarTarefa: 'Crear tarea',
    criarTarefaAjuda: 'Abre una tarjeta en Tareas vinculada a este registro',
    titulo: 'Nueva tarea a partir del registro',
    vinculadoA: 'Vinculada a: {{registro}}',
    criada: 'Tarea creada',
    abrirRegistro: 'Abrir el registro',
    semQuadro: 'Todavía no hay tableros en Tareas: crea uno en Tareas > Tableros.',
  },
  painel: {
    vazioTitulo: 'Aún hay pocos datos',
    vazioTexto: 'Las métricas aparecen cuando las tarjetas empiezan a avanzar por las columnas. Cada movimiento queda registrado con fecha y hora.',
    poucoDado: 'Con menos de 5 tarjetas concluidas, los números todavía oscilan mucho.',
    periodos: { '30': 'Últimos 30 días', '90': 'Últimos 90 días', '180': 'Últimos 180 días', '365': 'Últimos 12 meses' },
    leadTime: 'Lead time',
    leadAjuda: 'De la entrada a la conclusión',
    cycleTime: 'Cycle time',
    cycleAjuda: 'Del inicio del trabajo a la conclusión',
    esperaPessoa: 'Tiempo esperando a personas',
    esperaAjuda: '{{pct}} del lead time, en promedio',
    esperaSem: 'Sin tarjetas concluidas en el período',
    wip: 'WIP ahora',
    wipAjuda: 'Tarjetas en las columnas en curso',
    dias_one: '{{valor}} día',
    dias_other: '{{valor}} días',
    mediaMediana: 'Mediana {{mediana}}, P85 {{p85}}, {{n}} tarjetas',
    semConcluidos: 'Ninguna tarjeta concluida en el período',
    porColuna: 'Tiempo por columna',
    porColunaAjuda: 'Promedio de días de cada paso que empezó en el período. La columna con el mayor promedio es el cuello de botella.',
    gargalo: 'Cuello de botella',
    passagens_one: '{{count}} paso',
    passagens_other: '{{count}} pasos',
    atuais_one: '{{count}} ahora',
    atuais_other: '{{count}} ahora',
    vazao: 'Rendimiento semanal',
    vazaoAjuda: 'Tarjetas concluidas cada semana (de lunes a domingo)',
    semana: 'Semana del {{data}}',
    concluidos_one: '{{count}} concluida',
    concluidos_other: '{{count}} concluidas',
    retrabalho: 'Retrabajo',
    retrabalhoTexto_one: '{{cards}} de {{movidos}} tarjetas volvió de columna ({{voltas}} vuelta)',
    retrabalhoTexto_other: '{{cards}} de {{movidos}} tarjetas volvieron de columna ({{voltas}} vueltas)',
    retrabalhoSem: 'Ninguna tarjeta volvió de columna en el período',
    idade: 'Edad de las tarjetas abiertas',
    idadeAjuda: 'Días detenida en la columna actual',
    faixas: { ate_2: 'Hasta 2 días', de_3_a_7: '3 a 7 días', de_8_a_14: '8 a 14 días', mais_14: 'Más de 14 días' },
    maisParados: 'Más detenidas',
    paradoHa_one: 'detenida hace {{count}} día',
    paradoHa_other: 'detenida hace {{count}} días',
    semAbertos: 'Ninguna tarjeta abierta',
    origem: 'Origen de las tarjetas',
    origemAjuda: 'Tarjetas creadas en el período, por origen y por quién lo pidió',
    semOrigem: 'Ninguna tarjeta creada en el período',
    quemSem: 'Sin identificar',
    previsibilidade: 'Previsibilidad',
    previsibilidadeAjuda: 'Percentil 85 del lead time por tamaño, con todo el historial del tablero: el 85% de las tarjetas de ese tamaño quedó lista en ese plazo o antes.',
    semTamanho: 'Sin tamaño',
    p85: 'P85',
    mediana: 'Mediana',
    cards: 'Tarjetas',
    tamanho: 'Tamaño',
    semPrevisao: 'Aún no hay tarjetas concluidas',
    quantidade: 'Cantidad',
    coluna: 'Columna',
    media: 'Promedio',
  },
  quadros: {
    vazio: 'Aún no hay tableros.',
    colunas: 'Columnas',
    abertos_one: '{{count}} tarjeta abierta',
    abertos_other: '{{count}} tarjetas abiertas',
    novoTitulo: 'Nuevo tablero',
    novoTexto: 'Los tableros extra nacen con Por hacer, Haciendo y Hecho. Después, ajusta las columnas.',
    arquivarTitulo: '¿Archivar el tablero?',
    arquivarTexto: 'El tablero sale de las pantallas. Las tarjetas y el historial quedan guardados.',
    excluirColunaTitulo: '¿Eliminar la columna?',
    excluirColunaTexto: 'Solo se puede eliminar una columna vacía.',
    aprovacaoTexto: 'Activar, desactivar, eliminar o cambiar de lugar una columna que exige aprobación es decisión de quien aprueba.',
  },
  projetos: {
    novo: 'Nuevo proyecto',
    novoTexto: 'El proyecto nace en Registros (cliente, responsable, fechas y presupuesto) o usa uno que ya existe allí, y recibe un tablero con Por hacer, Haciendo y Hecho. Las etapas se ajustan en la pestaña Tableros.',
    criado: 'Proyecto creado',
    carregando: 'Cargando proyecto',
    vazioTitulo: 'Ningún proyecto todavía',
    vazioTexto: 'Crea un proyecto o abre el tablero de un proyecto de Registros, como el que nace al ganar una oportunidad.',
    soEquipe: 'Solo el equipo',
    arquivado: 'Archivado',
    semAcesso: 'Registro sin acceso',
    abrirKanban: 'Abrir en el kanban',
    abertas_one: '{{n}} abierta',
    abertas_other: '{{n}} abiertas',
    concluidas_one: '{{n}} concluida',
    concluidas_other: '{{n}} concluidas',
    atrasadas_one: '{{n}} atrasada',
    atrasadas_other: '{{n}} atrasadas',
    marcosFeitos: '{{feitos}} de {{total}} concluidos',
    equipe: 'Equipo',
    equipeRestrita: 'Solo el equipo, quien creó el proyecto y quien ve todos los proyectos ven este tablero.',
    equipeAberta: 'Todos con acceso a Tareas ven este tablero. El equipo cuenta cuando la visibilidad es "Solo el equipo".',
    semMembros: 'Nadie en el equipo todavía.',
    buscarMembro: 'Buscar persona',
    adicionarMembro: 'Agregar al equipo',
    removerMembro: 'Quitar a {{nome}} del equipo',
    visibilidadeAjuda: '"Solo el equipo": el tablero, las tareas y los hitos desaparecen para quien no es del equipo.',
    arquivar: 'Archivar proyecto',
    reabrir: 'Reabrir proyecto',
    arquivarTitulo: '¿Archivar el proyecto?',
    arquivarTexto: 'El proyecto sale de las listas y del kanban del día a día y queda para consulta. Nada entra ni se mueve en él hasta reabrirlo.',
    arquivadoTexto: 'Proyecto archivado: queda para consulta. Reábrelo para trabajar en las tareas y los hitos.',
    arquivadoAviso: 'Proyecto archivado',
    reabertoAviso: 'Proyecto reabierto',
    campos: {
      projeto: 'Proyecto',
      nomeQuadro: 'Nombre del proyecto',
      origem: 'Proyecto en Registros',
      projetoCadastros: 'Proyecto de Registros',
      cliente: 'Cliente',
      inicio: 'Inicio',
      fim: 'Fin previsto',
      orcamento: 'Presupuesto',
      visibilidade: 'Quién ve',
      tarefas: 'Tareas',
      proximoMarco: 'Próximo hito',
      marcos: 'Hitos',
      cadastro: 'Datos de Registros',
    },
    origens: { novo: 'Crear un proyecto nuevo', existente: 'Usar un proyecto que ya existe' },
    visibilidades: { todos: 'Todos con acceso a Tareas', equipe: 'Solo el equipo' },
    estados: { ativos: 'Activos', arquivados: 'Archivados', todos: 'Todos' },
    status: { planejado: 'Planificado', em_andamento: 'En curso', pausado: 'Pausado', concluido: 'Concluido', cancelado: 'Cancelado' },
  },
  vinculo: { projeto: 'Proyecto {{titulo}}', aberta: 'Abierta', concluida: 'Concluida' },
  marcos: {
    novo: 'Nuevo hito',
    editar: 'Editar hito',
    excluir: 'Eliminar hito',
    concluir: 'Concluir',
    reabrir: 'Reabrir',
    concluido: 'Concluido',
    pendente: 'Pendiente',
    concluidoAviso: 'Hito concluido',
    reabertoAviso: 'Hito reabierto',
    vazioTitulo: 'Ningún hito por aquí',
    vazioTexto: 'Los hitos de los proyectos aparecen aquí por fecha, el más cercano primero.',
    vazioProjeto: 'Ningún hito en este proyecto todavía.',
    semProjetos: 'Crea un proyecto antes de crear hitos.',
    excluirTitulo: '¿Eliminar el hito?',
    excluirTexto: 'El hito va a la papelera por 30 días.',
    campos: { projeto: 'Proyecto', data: 'Fecha', concluidoEm: 'Concluido el', acao: 'Acción' },
    estados: { pendentes: 'Pendientes', concluidos: 'Concluidos', todos: 'Todos' },
  },
};

export const i18n = { pt, en, es };
